export const FirebaseConfig = {
	"projectId": "smiles-805a8",
	"appId": "1:1017186275681:web:d7db0acd97a74d3fcdb520",
	"databaseURL": "https://smiles-805a8-default-rtdb.firebaseio.com",
	"storageBucket": "smiles-805a8.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDWyRzDYjTULHx-SH5MueL2o-rdr2Rsusg",
	"authDomain": "smiles-805a8.firebaseapp.com",
	"messagingSenderId": "1017186275681",
	"measurementId": "G-GE7ERBC888"
};